import React, { useEffect, useState } from 'react'
import { connect, useSelector, useDispatch } from 'react-redux'
import { compose } from 'redux'
import { useLocation, useHistory } from 'react-router-dom'
import { agencyEditData, deleteAgencySaga } from './saga'
import injectSaga from '../../utils/injectSaga'
import { agencyEdit, deleteAgency, hideModal } from '../App/actions'
import '../../fonts/fonts.css'
import SideBar from '../SideBar/index'
import PageHeader from '../../components/PageHeader'
import Pen from '../../images/pen.svg'
import ModalConfirm from '../../components/ModalConfirm'
import config from '../../config/configurator'
import {
  Bg, MainLayout,
  Container, SwitcherRow, SwitcherLabel, Selector,
  FormCard, Divider, SectionTitle,
  FieldGroup, FieldLabel, Input, FeedBack,
  ButtonContainer, DeleteButton, Button,
  SuccessToast, TrainingChoices, CheckboxChip,
} from './styledComponents'

const isB2VM = process.env.REACT_APP_TYPE === 'b2vm'
const editorPath = process.env.REACT_APP_SERVER_API
const whatApiToken = process.env.REACT_APP_WHATAPI_TOKEN

const getAgencyTrainingIds = (agency) => {
  if (Array.isArray(agency.agencyTrainingIds)) return agency.agencyTrainingIds.map(String)
  if (Array.isArray(agency.agencyTrainings) && agency.agencyTrainings.every(training => ['string', 'number'].includes(typeof training))) {
    return agency.agencyTrainings.map(String)
  }
  return []
}

const getStudentTrainingIds = (agency) => (
  Array.isArray(agency.studentTrainingIds)
    ? agency.studentTrainingIds.map(String)
    : []
)

const AgencyEdit = () => {
  const location = useLocation()
  const history = useHistory()
  const dispatch = useDispatch()
  const agencyToken = useSelector((state) => state.getIn(['global', 'agencytoken']))
  const error = useSelector((state) => state.getIn(['global', 'error']))
  const agenciesState = useSelector((state) => state.getIn(['global', 'agencies']))
  const agencies = agenciesState ? agenciesState.toJS() : []
  const isAdmin = useSelector((state) => state.getIn(['global', 'isAdmin']))
  const successStore = useSelector((state) => state.getIn(['global', 'success']))
  let agency

  const id = location.query ? location.query.id : location.pathname.split('/')[3]
  if (isB2VM) {
    agency = agencies ? agencies.find((a) => a.agencyId === id) : null
  } else {
    agency = agencies ? agencies.find((a) => a.id.toString() === id) : null
  }
  agency = agency || {}

  const [agencyId, setAgencyId] = useState()
  const [autorisation, setAutorisation] = useState(agency.autorisation)
  const [agencyPassword, setAgencyPassword] = useState('')
  const [repeatPassword, setRepeatPassowrd] = useState('')
  const [agencyName, setAgencyName] = useState(agency.agencyname || agency.agencyName)
  const [wrongRepeat, setWrongRepeat] = useState(false)
  const [errorCode, setErrorCode] = useState(0)
  const [email, setEmail] = useState(agency.email)
  const [notificationEmail, setNotificationEmail] = useState(agency.notificationEmail)
  const [enable, setEnable] = useState()
  const [warnMail, setWarnMail] = useState()
  const [warnNotificationEmail, setWarnNotificationEmail] = useState()
  const [backgroundColor, setBackgroundColor] = useState()
  const [color, setColor] = useState()
  const [showModal, setShowModal] = useState(false)
  const [modalText, setModalText] = useState()
  const [borderColorMail, setBorderColorMail] = useState()
  const [borderColorNotifMail, setBorderColorNotifMail] = useState()
  const [evalScaleDisplay, setEvalScaleDisplay] = useState()
  const [success, setSuccess] = useState(false)
  const [entity, setEntity] = useState(agency.entity || 'TGD')
  const [agencyTrainings, setAgencyTrainings] = useState(agency.agencyTrainings)
  const [agencyTrainingIds, setAgencyTrainingIds] = useState(getAgencyTrainingIds(agency))
  const [agencyStudentTrainings, setAgencyStudentTrainings] = useState(getStudentTrainingIds(agency))
  const [trainings, setTrainings] = useState([])
  const [studentTrainingsList, setStudentTrainingsList] = useState([])
  console.log('agency.agencyTrainings', agency.agencyTrainings)
  console.log('agency', agency)
  useEffect(() => {
    fetch(`${editorPath}/api/trainings?access_token=${whatApiToken}`)
      .then(r => r.json())
      .then(data => {
        if (!Array.isArray(data)) return
        setTrainings(data.filter(t => t.isAgencyTraining !== false))
        setStudentTrainingsList(data.filter(t => t.isAgencyTraining === false))
      })
      .catch(() => {})
  }, [])

  useEffect(() => {
    displayModal(successStore)
    checkPassword()
    checkError()
    setAgencyId(agency.id || agency.agencyId)
    setAutorisation(agency.autorisation)
    setAgencyName(agency.agencyname || agency.agencyName)
    setEmail(agency.email)
    setNotificationEmail(agency.notificationEmail)
    setEntity(agency.entity || 'TGD')
    setAgencyTrainings(agency.agencyTrainings)
    setAgencyTrainingIds(getAgencyTrainingIds(agency))
    setAgencyStudentTrainings(getStudentTrainingIds(agency))
    setEvalScaleDisplay(
      agency.evalScaleDisplay === 'hours' ?
      1 : agency.evalScaleDisplay === 'seq' ?
        2 : 0
      )
    // eslint-disable-next-line
  }, [agency.id, agencyPassword, repeatPassword, successStore])

  const displayModal = (show) => {
    if(show){
      setSuccess(true)
      setTimeout(() => {
        dispatch(hideModal())
        setSuccess(false)
      }, 2000)
    }
  }

  const checkPassword = () => {
    if (agencyPassword && repeatPassword) {
      if (agencyPassword !== repeatPassword) {
        setWrongRepeat(true)
        setBackgroundColor('#EFF0F6')
        setColor('#868383')
        setEnable(false)
      } else if (agencyPassword && repeatPassword && (agencyPassword === repeatPassword)) {
        setWrongRepeat(false)
        setBackgroundColor('#00C4F3')
        setColor('black')
        setEnable(true)
      }
      if (agencyPassword === repeatPassword) {
        setWrongRepeat(false)
      }
    }
  }

  const checkError = () => {
    if (error !== undefined) {
      if (error.response !== undefined) {
        if (errorCode !== error.response.status) {
          setErrorCode(error.response.status)
        }
      }
    }
  }

  function verification () {
    if (agencyName) {
      if (!wrongRepeat) {
        if (emailCheck(email, null) && emailCheck(null, notificationEmail)) {
          setBackgroundColor('#00C4F3')
          setColor('black')
          setEnable(true)
        } else {
          setBackgroundColor('#EFF0F6')
          setColor('#868383')
          setEnable(false)
        }
      }
    } else {
      setBackgroundColor('#868383')
      setColor('#868383')
      setEnable(false)
    }
  }

  const onKeyPress = (event) => {
    if (event.key === 'Enter') {
      clickHandlerAccount()
    }
  }

  function clickHandlerAccount () {
    const agencyData = {
      id: agencyId,
      agencyname: agencyName,
      email: email,
      notificationEmail: notificationEmail,
      password: agencyPassword,
      entity: entity,
      token: agencyToken,
      evalScaleDisplay: evalScaleDisplay,
      autorisation: autorisation,
      agencyTrainings: agencyTrainings,
      agencyTrainingIds: agencyTrainingIds,
      studentTrainingIds: agencyStudentTrainings
    }
    Object.keys(agencyData).forEach(k => {
      if(agencyData[k] == null) { delete agencyData[k] }
    })
    if(agencyData.password === '') { delete agencyData.password }
    dispatch(agencyEdit(agencyData))
    setErrorCode(200)
    setBackgroundColor('#EFF0F6')
    setColor('#868383')
    setEnable(false)
    setAgencyPassword('')
    setRepeatPassowrd('')
    setTimeout(() => { setErrorCode(0) }, 2000)
  }

  function confirmDelete (id, action) {
    setShowModal(true)
    setModalText(`${action}`)
  }

  const deleteCurrentAgency = (id) => {
    dispatch(deleteAgency(agencyToken, id))
    history.push('/agencies')
  }

  function handleChangeAgency (e) {
    history.push(`/agency/edit/${e.value}`)
    let newAgency
    if (isB2VM) {
      newAgency = agencies.find(ag => ag.agencyId === e.value)
    } else {
      newAgency = agencies.find(ag => ag.id.toString() === e.value)
    }
    setAgencyId(e.value)
    setAgencyName(newAgency.agencyname || newAgency.agencyName)
    setEmail(newAgency.email)
    setNotificationEmail(newAgency.notificationEmail)
    setAutorisation(newAgency.autorisation || newAgency.agencyName)
    setEntity(newAgency.entity || 'TGD')
    setEvalScaleDisplay(newAgency.evalScaleDisplay)
    setAgencyTrainings(newAgency.agencyTrainings)
    setAgencyTrainingIds(getAgencyTrainingIds(newAgency))
    setAgencyStudentTrainings(getStudentTrainingIds(newAgency))
    setBackgroundColor('#EFF0F6')
    setColor('#868383')
    setEnable(false)
    if (isAdmin) { setAgencyId(newAgency.agencyId) }
  }

  function displayAgencySelector () {
    if (Object.keys(agency).length > 0 && Array.isArray(agencies)) {
      const agencyValues = []
      agencies.forEach((ag) => agencyValues.push({ value: ag.agencyId, label: ag.agencyName }))
      let currentAgencyIndex = agencyValues.indexOf(agencyValues.find((ag) => ag.value === agencyId))
      if (!agencyValues[currentAgencyIndex]) return null
      return (
        <Selector
          classNamePrefix='react-select'
          multiple={false}
          isSearchable={false}
          defaultValue={agencyValues[currentAgencyIndex]}
          onChange={(e) => { handleChangeAgency(e) }}
          options={agencyValues}
        />
      )
    }
  }

  function emailCheck (email, notifMail) {
    if (email && notifMail == null) {
      if (email !== null && email !== '') {
        const expReg = /\S+@\S+\.\S+/
        const result = email.match(expReg)
        if (result == null) {
          setBorderColorMail('#FF0000')
          setWarnMail(true)
          return false
        }
      }
      setBorderColorMail('#B3ABBC')
      setWarnMail(false)
      return true
    } else if (email == null && notifMail) {
      if (notifMail !== null && notifMail !== '') {
        const expReg = /\S+@\S+\.\S+/
        const result = notifMail.match(expReg)
        if (result == null) {
          setBorderColorNotifMail('#FF0000')
          setWarnNotificationEmail(true)
          return false
        }
      }
      setBorderColorNotifMail('#B3ABBC')
      setWarnNotificationEmail(false)
      return true
    }
    return true
  }

  return (
    <Bg>
      <SideBar />
      <MainLayout>
        {success && (
          <SuccessToast>✓ {agencyName} a été modifiée.</SuccessToast>
        )}
        <ModalConfirm
          show={showModal}
          confirmText='Supprimer'
          text={modalText}
          name={agencyName}
          confirm={() => deleteCurrentAgency(agencyId)}
          cancel={() => setShowModal(false)}
        />

        <PageHeader icon={Pen} title='Le compte agence' subtitle={agencyName || 'Modifier le profil'} />

        <Container>

          {/* ── Sélecteur d'agence ── */}
          <SwitcherRow>
            <SwitcherLabel>Sélectionner une agence</SwitcherLabel>
            {displayAgencySelector()}
          </SwitcherRow>

          <FormCard>

            {/* ── Informations ── */}
            <div>
              <SectionTitle>Informations</SectionTitle>
              <FieldGroup>
                <FieldLabel>Nom de l'agence</FieldLabel>
                <Input
                  value={agencyName}
                  onChange={(e) => { setAgencyName(e.target.value); verification() }}
                />
              </FieldGroup>

              {config.title !== 'ML ADMIN' && (
                <>
                  {!isB2VM && (
                    <FieldGroup style={{ marginTop: '1rem' }}>
                      <FieldLabel>Email</FieldLabel>
                      <Input
                        value={email}
                        type='text'
                        style={{ borderColor: borderColorMail }}
                        onChange={(e) => { setEmail(e.target.value); emailCheck(email, null); verification() }}
                      />
                      {warnMail && <FeedBack>Email non valide</FeedBack>}
                    </FieldGroup>
                  )}

                  {config.features.simu && (
                    <FieldGroup style={{ marginTop: '1rem' }}>
                      <FieldLabel>Email de notification</FieldLabel>
                      <Input
                        value={notificationEmail}
                        type='text'
                        style={{ borderColor: borderColorNotifMail }}
                        onChange={(e) => { setNotificationEmail(e.target.value); emailCheck(null, notificationEmail); verification() }}
                      />
                      {warnNotificationEmail && <FeedBack>Email non valide</FeedBack>}
                    </FieldGroup>
                  )}
                </>
              )}
            </div>

            <Divider />

            {/* ── Accès ── */}
            <div>
              <SectionTitle>Changer le mot de passe</SectionTitle>
              <FieldGroup>
                <FieldLabel>Nouveau mot de passe</FieldLabel>
                <Input
                  placeholder='••••••'
                  value={agencyPassword}
                  type='text'
                  style={{ borderColor: wrongRepeat ? '#EF4444' : '' }}
                  onChange={(e) => { setAgencyPassword(e.target.value); verification() }}
                />
              </FieldGroup>
              <FieldGroup style={{ marginTop: '1rem' }}>
                <FieldLabel>Répéter le mot de passe</FieldLabel>
                <Input
                  placeholder='••••••'
                  value={repeatPassword}
                  type='text'
                  style={{ borderColor: wrongRepeat ? '#EF4444' : '' }}
                  onKeyPress={onKeyPress}
                  onChange={(e) => { setRepeatPassowrd(e.target.value); verification() }}
                />
                {wrongRepeat && <FeedBack>Les mots de passe ne correspondent pas</FeedBack>}
              </FieldGroup>
            </div>

            <Divider />

            {/* ── Type d'agence (PP ADMIN) ── */}
            {config.title === 'PP ADMIN' && (
              <>
                <div>
                  <SectionTitle>Type d'agence</SectionTitle>
                  <FieldGroup>
                    <FieldLabel>Entité</FieldLabel>
                    <Input
                      value={entity}
                      type='text'
                      onKeyPress={onKeyPress}
                      onChange={(e) => { setEntity(e.target.value); verification() }}
                    />
                  </FieldGroup>
                </div>
                <Divider />
              </>
            )}

            {/* ── Agrément ── */}
            <div>
              <SectionTitle>Agrément</SectionTitle>
              <FieldGroup>
                <FieldLabel>N° d'autorisation d'enseigner</FieldLabel>
                <Input
                  value={autorisation}
                  onKeyPress={onKeyPress}
                  onChange={(e) => { setAutorisation(e.target.value); verification() }}
                />
              </FieldGroup>
            </div>

            <Divider />

            {/* ── Formations Agence Autorisées ── */}
            {trainings.length > 0 && (
              <>
                <div>
                  <SectionTitle>Formations Agence Autorisées</SectionTitle>
                  <FieldLabel as='p' style={{ marginBottom: '0.75rem' }}>Ces formations sont accessibles sur le simulateur dès que l’agence est connectée.</FieldLabel>
                  <TrainingChoices>
                    {trainings.map(t => {
                      const trainingId = String(t.id)
                      const checked = Array.isArray(agencyTrainingIds) && agencyTrainingIds.includes(trainingId)
                      return (
                        <CheckboxChip
                          key={t.id}
                          $checked={checked}
                          onClick={() => {
                            const current = Array.isArray(agencyTrainingIds) ? agencyTrainingIds : []
                            const next = checked
                              ? current.filter(id => id !== trainingId)
                              : [...current, trainingId]
                            setAgencyTrainingIds(next)
                            setBackgroundColor('#00C4F3')
                            setColor('black')
                            setEnable(true)
                          }}
                        >
                          {t.title}
                        </CheckboxChip>
                      )
                    })}
                  </TrainingChoices>
                </div>
                <Divider />
              </>
            )}

            {/* ── Formations Elève Globale Autorisées ── */}
            {studentTrainingsList.length > 0 && (
              <>
                <div>
                  <SectionTitle>Formations Elève Globale Autorisées</SectionTitle>
                  <FieldLabel as='p' style={{ marginBottom: '0.75rem' }}>Ces formations sont accessibles gratuitement sur le simulateur dès que l’élève est connecté.</FieldLabel>
                  <TrainingChoices>
                    {studentTrainingsList.map(t => {
                      const tid = t.id.toString()
                      const checked = Array.isArray(agencyStudentTrainings) && agencyStudentTrainings.includes(tid)
                      return (
                        <CheckboxChip
                          key={t.id}
                          $checked={checked}
                          onClick={() => {
                            const current = Array.isArray(agencyStudentTrainings) ? agencyStudentTrainings : []
                            const next = checked
                              ? current.filter(id => id !== tid)
                              : [...current, tid]
                            setAgencyStudentTrainings(next)
                            setBackgroundColor('#00C4F3')
                            setColor('black')
                            setEnable(true)
                          }}
                        >
                          {t.title}
                        </CheckboxChip>
                      )
                    })}
                  </TrainingChoices>
                </div>
                <Divider />
              </>
            )}

            {/* ── Actions ── */}
            <ButtonContainer>
              <DeleteButton
                onClick={() => confirmDelete(agencyId, 'Attention, vous allez supprimer définitivement l\'agence ')}
              >
                Supprimer
              </DeleteButton>
              <Button
                disabled={!enable}
                onClick={() => clickHandlerAccount()}
              >
                Modifier l'agence
              </Button>
            </ButtonContainer>

          </FormCard>
        </Container>
      </MainLayout>
    </Bg>
  )
}

const withConnect = connect(null, null)
const withSaga = injectSaga({ key: 'AgencyEdit', saga: agencyEditData })
const withDeleteSaga = injectSaga({ key: 'AgencyDelete', saga: deleteAgencySaga })
const arg = compose(withSaga, withDeleteSaga, withConnect)(AgencyEdit)

export default arg
